var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6856 10.1775L23.5606 1.55249C23.2012 1.39437 22.7844 1.39437 22.425 1.55249L2.31438 10.1775C1.7825 10.4075 1.4375 10.925 1.4375 11.5V16.3012L22.4394 7.30249C22.7987 7.14437 23.2156 7.14437 23.575 7.30249L44.5769 16.3012V11.5C44.5769 10.925 44.2319 10.4075 43.7 10.1775H43.6856Z",
    fill: "url(#paint0_linear_0_3698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.125 34.5H40.9688V17.8969L23 10.1919L5.03125 17.8969V34.5H2.875C2.08437 34.5 1.4375 35.1469 1.4375 35.9375C1.4375 36.7281 2.08437 37.375 2.875 37.375H9.28625C8.855 36.0094 8.625 34.5575 8.625 33.0625C8.625 25.1419 15.0794 18.6875 23 18.6875C30.9206 18.6875 37.375 25.1419 37.375 33.0625C37.375 34.5575 37.145 36.0094 36.7138 37.375H43.125C43.9156 37.375 44.5625 36.7281 44.5625 35.9375C44.5625 35.1469 43.9156 34.5 43.125 34.5Z",
    fill: "url(#paint1_linear_0_3698)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21.5625C16.6606 21.5625 11.5 26.7231 11.5 33.0625C11.5 39.4019 16.6606 44.5625 23 44.5625C29.3394 44.5625 34.5 39.4019 34.5 33.0625C34.5 26.7231 29.3394 21.5625 23 21.5625ZM21.8069 31.625H24.2075C26.3206 31.625 28.0456 33.35 28.0456 35.4631C28.0456 37.5763 26.45 39.1431 24.4519 39.2725V40.25C24.4519 41.0406 23.805 41.6875 23.0144 41.6875C22.2238 41.6875 21.5769 41.0406 21.5769 40.25V39.2869H19.4206C18.63 39.2869 17.9831 38.64 17.9831 37.8494C17.9831 37.0588 18.63 36.4119 19.4206 36.4119H24.2075C24.7394 36.4119 25.1706 35.9806 25.1706 35.4487C25.1706 34.9169 24.7394 34.4856 24.2075 34.4856H21.8069C19.6938 34.4856 17.9688 32.7606 17.9688 30.6475C17.9688 28.5344 19.5644 26.9675 21.5625 26.8381V25.8606C21.5625 25.07 22.2094 24.4231 23 24.4231C23.7906 24.4231 24.4375 25.07 24.4375 25.8606V26.8237H26.5938C27.3844 26.8237 28.0312 27.4706 28.0312 28.2612C28.0312 29.0519 27.3844 29.6987 26.5938 29.6987H21.8069C21.275 29.6987 20.8438 30.13 20.8438 30.6619C20.8438 31.1937 21.275 31.625 21.8069 31.625Z",
    fill: "url(#paint2_linear_0_3698)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_3698",
    x1: 4.36584,
    y1: -0.026289,
    x2: 46.1191,
    y2: 8.24598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_3698",
    x1: 4.36486,
    y1: 7.52209,
    x2: 47.2395,
    y2: 12.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_3698",
    x1: 13.0613,
    y1: 19.3036,
    x2: 36.0887,
    y2: 20.8759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#577EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B22ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/rent.7aa5ce702fe157257508a513eb1029cc.svg";
export { ForwardRef as ReactComponent };